// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

import type { ReactNode } from 'react'

import type { VoltraBaseProps } from '../baseProps'

export type GroupBoxProps = VoltraBaseProps & {
  /** Label content for the group box */
  label?: ReactNode
}
